import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyDateRangePickerComponent } from './formly-daterangepicker.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

export const FieldTypeDateRangepicker = 'daterangepicker';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    FormlyModule.forChild({
      types: [
        {
          name: FieldTypeDateRangepicker,
          component: FormlyDateRangePickerComponent,
        },
      ],
    }),
    MatButtonModule,
    MatSelectModule,
    FormsModule,
  ],
  declarations: [FormlyDateRangePickerComponent],
})
export class FormFieldsDateRangePickerModule {}
